/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringManagementErrorResponseCorrelationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const MonitoringManagementErrorResponse = zod.object({
  code: zod.enum([
    'INVALID_REQUEST',
    'SESSION_REQUIRED',
    'CAPABILITY_DENIED',
    'NOT_FOUND',
    'VERSION_CONFLICT',
    'IDEMPOTENCY_CONFLICT',
    'TEAM_INACTIVE',
    'CUSTOMER_ARCHIVED',
    'PRIORITY_FIELD_REQUIRED',
    'INTEGRATION_RETIRED',
    'INTEGRATION_NOT_RETIRED',
    'PAYLOAD_TOO_LARGE',
    'RATE_LIMITED',
    'STORAGE_UNAVAILABLE',
    'INTERNAL_ERROR',
  ]),
  message: zod.enum(['Monitoring integration request could not be completed.']),
  correlationId: zod.uuid().regex(monitoringManagementErrorResponseCorrelationIdRegExp),
});

export type MonitoringManagementErrorResponse = zod.input<typeof MonitoringManagementErrorResponse>;
export type MonitoringManagementErrorResponseOutput = zod.output<
  typeof MonitoringManagementErrorResponse
>;
